import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { selectLoggedIn, selectUser } from "../../store/slices/auth/slice";

const ProtectedRoute = ({ allowedRoles = null }) => {
  const loggedIn = useSelector(selectLoggedIn);
  const user = useSelector(selectUser);
  const location = useLocation();

  // If authentication status is still loading
  if (loggedIn === null) {
    return null;
  }

  // If not logged in, redirect to login
  if (!loggedIn) {
    return <Navigate to="/login" replace />;
  }

  // If logged in but no role info, wait for user data
  if (!user?.role) {
    return null;
  }

  // Role-based access control
  const currentPath = location.pathname;

  // Admin trying to access band routes
  if (user?.role === "admin" && currentPath.startsWith("/bend-panel/")) {
    return <Navigate to="/admin-panel/kontrolna-tabla" replace />;
  }

  // Band trying to access admin routes
  if (user?.role === "band" && currentPath.startsWith("/admin-panel/")) {
    return <Navigate to="/bend-panel/kontrolna-tabla" replace />;
  }

  // If allowedRoles is specified, check role access
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    const redirectPath =
      user?.role === "admin"
        ? "/admin-panel/kontrolna-tabla"
        : "/bend-panel/kontrolna-tabla";
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
